import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _TxNodeGetter = Getter.of();
export const _TxNodeResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _TxNodeResponse2TxNode = _Response2ResponseData();
export const _TxNode2Data = Fold.compose(_TxNodeGetter, Res._Response());
export const _TxNode2Attributes = Fold.compose(_TxNode2Data, Lens.prop("attributes"));
export const _TxNodeAttributes2AlternateId = Fold.compose(_TxNode2Attributes, Lens.prop("alternateId"));
export const _TxNodeAttributes2Description = Fold.compose(_TxNode2Attributes, Lens.prop("description"));
export const _TxNodeAttributes2Kind = Fold.compose(_TxNode2Attributes, Lens.prop("kind"));
export const _TxNodeAttributes2Name = Fold.compose(_TxNode2Attributes, Lens.prop("name"));
export const _TxNode2Images = Fold.compose(_TxNodeGetter, Res._Rel("images"), Res._ForEach());
export const _TxNode2Routes = Fold.compose(_TxNodeGetter, Res._Rel("routes"), Res._ForEach());

